import { render } from "./SliderBasic.vue?vue&type=template&id=442d31be&scoped=true"
import script from "./SliderBasic.vue?vue&type=script&lang=js"
export * from "./SliderBasic.vue?vue&type=script&lang=js"

import "./SliderBasic.vue?vue&type=style&index=0&id=442d31be&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-442d31be"

export default script